<rid-morpheme-board
  class="h-dvh"
  [prompts]="[
    {
      prompt: {
        type: 'AUDIO',
        size: 'SMALL',
        src: { pronounce: 'verslapen' },
      },
      prefix: 'ver-',
      suffix: '-en',
      stem: 'slaap',
      center: ['s', 'l', 'aa', 'p'],
    },
    {
      prompt: {
        type: 'AUDIO',
        size: 'SMALL',
        src: { pronounce: 'gebruik' },
      },
      prefix: 'ge-',
      stem: 'bruik',
      center: ['b', 'r', 'ui', 'k'],
    },
    {
      prompt: {
        type: 'AUDIO',
        size: 'SMALL',
        src: { pronounce: 'regelbaar' },
      },
      suffix: '-baar',
      stem: 'regel',
      center: ['r', 'e', 'g', 'e', 'l'],
    },
    {
      prompt: {
        type: 'AUDIO',
        size: 'SMALL',
        src: { pronounce: 'zonnig' },
      },
      suffix: '-ig',
      stem: 'zon',
      center: ['z', 'o', '+', 'n'],
    },
  ]"
  (finished)="$router.navigate(['/mechanics/morpheme-board'])"
/>
